import React, { useState } from 'react';
import styled from 'styled-components';

import { CopyInput, Heading, Button, Formatted } from '@agilytics/components';
import { shareButtonText, shareHeading, content, copyAction, copyMessage } from './content.json';

const ShareContainer = styled.aside`
  text-align: center;
  max-width: 400px;
  margin: 0 auto;
  padding: ${({ theme }) => theme.spacingDouble};
`;

const ShareButtonContainer = styled.div`
  margin-top: ${({ theme }) => theme.spacingDouble};
`;

export default function Share({ shareUrl, children, onClickShare = () => {}, nativeShareEnabled }) {
  const [showButtons, setShowButtons] = useState(false);

  const onClick = () => {
    onClickShare();
    if (!nativeShareEnabled) {
      setShowButtons(true);
    }
  };

  return (
    <ShareContainer>
      <Heading level={4}>{shareHeading}</Heading>
      <Formatted content={content} />
      <Button outline onClick={onClick}>
        <svg width="27px" height="26px" viewBox="0 0 27 26" version="1.1">
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g transform="translate(-473.000000, -867.000000)" fill="#000000" fillRule="nonzero">
              <g transform="translate(449.000000, 854.000000)">
                <g transform="translate(24.000000, 13.000000)">
                  <path
                    d="M22.17029,0.35165424 C21.7307274,-0.117218095 21.0180558,-0.117218078 20.5784933,0.351654278 C20.1389307,0.820526635 20.1389307,1.58071892 20.5784932,2.0495913 L23.1574289,4.80048932 L15.1871958,4.80048932 C11.7701019,4.80048932 9,7.75530043 9,11.4002447 C9,15.0451889 11.7701019,18 15.1871958,18 C15.8084856,18 16.3121405,17.4627616 16.3121405,16.8000445 C16.3121405,16.1373274 15.8084856,15.600089 15.1871958,15.600089 C13.0126815,15.6000889 11.2498895,13.7197546 11.2498895,11.4002447 C11.2498895,9.08073473 13.0126815,7.2004004 15.1871958,7.20040035 L23.1574289,7.20040035 L20.5784932,9.95129837 C20.1389307,10.4201707 20.1389307,11.1803631 20.5784932,11.6492354 C21.0180558,12.1181078 21.7307274,12.1181078 22.17029,11.6492354 L26.6700687,6.84941336 C26.8813075,6.6243398 27,6.31892413 27,6.00044483 C27,5.68196554 26.8813075,5.37654987 26.6700687,5.15147631 L22.17029,0.35165424 Z"
                    id="Path"
                  ></path>
                  <path
                    d="M0,8.5 L0,22.5 C5.24832703e-16,24.4329966 1.58735407,26 3.54545455,26 L22.4545455,26 C24.4126459,26 26,24.4329966 26,22.5 L26,15.5 C26,14.8556678 25.470882,14.3333333 24.8181818,14.3333333 C24.1654817,14.3333333 23.6363636,14.8556678 23.6363636,15.5 L23.6363636,22.5 C23.6363636,23.1443322 23.1072456,23.6666667 22.4545455,23.6666667 L3.54545455,23.6666667 C2.89275439,23.6666667 2.36363636,23.1443322 2.36363636,22.5 L2.36363636,8.5 C2.36363636,7.85566779 2.89275439,7.33333333 3.54545455,7.33333333 L7.09090909,7.33333333 C7.74360925,7.33333333 8.27272727,6.81099887 8.27272727,6.16666667 C8.27272727,5.52233446 7.74360925,5 7.09090909,5 L3.54545455,5 C1.58735407,5 5.24832703e-16,6.56700338 0,8.5 Z"
                    id="Path"
                  ></path>
                </g>
              </g>
            </g>
          </g>
        </svg>
        {shareButtonText}
      </Button>

      {showButtons ? <ShareButtonContainer>{children}</ShareButtonContainer> : null}
      {showButtons ? <CopyInput value={shareUrl} action={copyAction} copiedMessage={copyMessage} /> : null}
    </ShareContainer>
  );
}
